import { BilledOperationGetResponse } from "./../../types/billedOperation";
import { CacheKeys } from "./../cacheKeys";
import { Endpoints } from "./../endpoints";
import { ssoApi } from "./../index";

export const billedOperationsApi = ssoApi
  .enhanceEndpoints({ addTagTypes: [CacheKeys.BILLED_OPERATIONS, CacheKeys.BILLED_OPERATION_SUMMARIES] })
  .injectEndpoints({
    endpoints: builder => ({
      billedOperations: builder.query<BilledOperationGetResponse, string>({
        query: query => ({ url: `${Endpoints.BILLED_OPERATIONS}/?${query}` }),
        providesTags: [CacheKeys.BILLED_OPERATIONS],
      }),
      organisationSummaries: builder.query<any, string>({
        query: query => ({url: `${Endpoints.BILLED_OPERATIONS}/GetOrganisationSummary?${query}` }),
        providesTags: [CacheKeys.BILLED_OPERATION_SUMMARIES],
      })
    }),
  });

export const { useBilledOperationsQuery, useOrganisationSummariesQuery } = billedOperationsApi;
